export default "__VITE_ASSET__040772b3__"